import { styled } from '@mui/material';

import RichTextView from '../../../../../../components/RichText/View';
import { generateClasses } from '../../../../../../utils/helper';

export const publishedQuestionDescriptionClasses = generateClasses('PublishedQuestionDescription', [
  'readonlyDescription',
  'temporaryReadonlyDescription',
]);

export const Root = styled('div')(({ theme }) => ({
  overflow: 'hidden',
  position: 'relative',
  [`& .${publishedQuestionDescriptionClasses.temporaryReadonlyDescription}`]: {
    position: 'absolute',
    inset: 0,
    zIndex: -1,
  },
}));

export const ReadonlyDescription = styled(RichTextView)<{ fontSize: number }>(({ fontSize }) => ({
  height: '100%',
  fontSize,
  overflowY: 'auto',
}));

export const TemporaryReadonlyDescription = styled(RichTextView)(({ theme }) => ({
  opacity: 0,
}));
